import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Label from "components/general/Label";
import SvgMirs from "components/presentation/SvgMirs";

export function ScoreContainer(props) {
  const { resultObj, competitorPos } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const winner = resultObj?.wlt === 'W' && <div className='score-winner'><SvgMirs className='mirsIcon score-winner' title='HeaderWinner' code='circle-check' /></div>
  const result = resultObj?.result ? <>{resultObj?.result}</> : '';
  const cols = resultObj?.hasIRM ? '' : ''
  const record = resultObj?.extra?.record ? <>{resultObj?.extra?.record}</> : '';

  let rrResult = resultObj?.extra?.rrResult ? resultObj?.extra?.rrResult : '';
  if (rrResult === 'Fall') {
    rrResult = <SportCode discipline='CLB' entity='@IRM' code={'Fall'} abbr={true} />;
  } else if (rrResult === 'FS') {
    rrResult = <SportCode discipline='CLB' entity='@IRM' code={'FS'} abbr={true} />;
  }

  const rrRecord = resultObj?.extra?.rrRecord ? <>{resultObj?.extra?.rrRecord}</> : '';

  let out = (
    <>
      <div className="score-result-container">
        {competitorPos === '1' && <div className="text-end fw-bold"><Label data='HeaderTime' /></div>}
        <div className=' d-flex justify-content-end align-self-center'>
          {winner}
          &nbsp;
          &nbsp;
          &nbsp;
          <div className={`${cols} ${resultObj?.rCn ? resultObj?.rCn : ''} p-0 text-end`}>
            {result} {record}
          </div>
          {resultObj?.hasIRM === true
            ? <div className={`${cols}`}>
              <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
            </div>
            : ''
          }
        </div>
      </div>
    </>
  )

  if (rrResult) {
    out = (
      <>
        <div className='score-result-container'>
          {competitorPos === '1' && <div className="text-end fw-bold"><Label data='HeaderTime' /></div>}
          <div className='d-flex justify-content-end align-self-center'>
            {winner}
            <div className={`${cols} ${resultObj?.rCn ? resultObj?.rCn : ''} p-0 text-end `}>
              {rrResult} {rrRecord}
            </div>
          </div>
          <div className='d-flex justify-content-end align-self-center'>
            <div className={`${cols} ${resultObj?.rCn ? resultObj?.rCn : ''} p-0 text-end `}>
              {'RR'} {result} {record}
            </div>
            {resultObj?.hasIRM === true
              ? <div className={`${cols} px-1 `}>
                <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
              </div>
              : ''
            }
          </div>
        </div>
      </>
    )
  }

  return (<>{out}</>)
}

export default ScoreContainer
